import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { displayGlobalMessage, hideGlobalMessage } from '../../../actions/globalMessage';
import PropTypes from 'prop-types';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function GlobalMessage(props) {
  const dispatch = useDispatch();

  const messageDataFromRedux = useSelector((state) => state.globalMessageReducer.messageData);

  const [messageData, setMessageData] = useState(messageDataFromRedux || {});
  const [hidden, setHidden] = useState(true);
  const [autoHideTimeoutHandler, setAutoHideTimeoutHandler] = useState('');
  const globalMessageContainer = useRef(null);

  const hideMessage = () => {
    messageData.visible = false;
    //setMessageData(messageData);
    globalMessageContainer.current.className = globalMessageContainer.current.className + ' slide-to-top';

    //Dispatching event for hiding message with the details
    var evt = new CustomEvent('globalMessageHidden', {
      detail: messageData,
    });
    window.dispatchEvent(evt);
    if (messageDataFromRedux && messageDataFromRedux.gotItCallBack) {
      messageDataFromRedux.gotItCallBack();
    }
    setTimeout(() => {
      dispatch(hideGlobalMessage());
    }, 500);
  };

  useEffect(() => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    let messageDataLocal = messageDataFromRedux || {};
    if (messageData && messageData.alwaysOnTop) {
      return;
    }

    if (autoHideTimeoutHandler) clearTimeout(autoHideTimeoutHandler);
    setMessageData(messageDataFromRedux || {});
    if (messageDataFromRedux == null || JSON.stringify(messageDataFromRedux) == '{}') setHidden(true);
    else {
      setHidden(false);
      if (messageDataFromRedux && messageDataFromRedux.autoHide) {
        var handler = setTimeout(() => {
          hideMessage();
        }, 5000);
        setAutoHideTimeoutHandler(handler);
      }
      if (messageDataFromRedux && messageDataFromRedux.alwaysOnTop == true) {
        //we just clear the error if always on top is true. this enables us not to show the error message again after refresh
        dispatch(displayGlobalMessage({}));
      }
    }
  }, [messageDataFromRedux]);

  let animationState = messageData.visible ? ' slide-from-top ' : ' slide-to-top ';
  let hiddenOrNot = hidden ? ' hidden ' : '';
  let gotItButton = (
    <div className="ui labeled button arrow">
      <div
        className="ui small  mrls hand button got-it-btn color-white text-size-l"
        onClick={() => {
          if (messageData.btnOnclick) messageData.btnOnclick();
          hideMessage();
        }}
      >
        {messageDataFromRedux && messageDataFromRedux.gotItButtonText
          ? messageDataFromRedux.gotItButtonText
          : APP.LANGUAGE.DismissGlobalMessageGood}
      </div>
    </div>
  );
  if ((messageData.autoHide || messageData.alwaysOnTop == true) && !messageData.enableHideAndBtn) {
    //if always on Top is true then there is no point of showing GotIt Button
    gotItButton = '';
  }
  if (messageData.alwaysOnTop == true) {
    const showSpinner = document.getElementById('overlay');
    let domHotjarPlugin = document.getElementById('_hj_feedback_container');
    showSpinner.style.display = 'block'; //for displaying the spinner again
    if (domHotjarPlugin) domHotjarPlugin.style.visibility = 'hidden'; //hidden the hotjar
  }
  let messageClasses =
    'global-message  ui  message txt-size-m absolute z-l   pdm box-shadow-null txt-centered  ' +
    animationState +
    hiddenOrNot;
  if (messageData.messageType && messageData.messageType == APP.LANGUAGE.GlobalMessageTypes.Good) {
    messageClasses += ' color-good-things-bg'; //' bg-good-color';//' color-good-things color-good-things:hover';
  } else if (messageData.messageType && messageData.messageType == APP.LANGUAGE.GlobalMessageTypes.Warning) {
    messageClasses += ' color-button-warning';
  } else {
    messageClasses += ' color-bad-things-bg'; //' bg-bad-color';//' color-bad-things color-bad-things:hover';
  }

  var message = '';
  if (messageData.text && messageData.text != '') {
    if (messageDataFromRedux?.linkText && messageDataFromRedux?.linkText != '') {
      message = (
        <div className={messageClasses} ref={globalMessageContainer}>
          <span className="color-white text-size-l">{messageData.text}</span>
          <a className="color-white text-size-l global-message-link" onClick={messageDataFromRedux?.linkCallBack}>
            {messageData?.linkText}
          </a>
          {gotItButton}
        </div>
      );
    } else {
      message = (
        <div className={messageClasses} ref={globalMessageContainer}>
          <span
            className="color-white text-size-l"
            dangerouslySetInnerHTML={{
              __html: messageData.text,
            }}
          />
          {gotItButton}
        </div>
      );
    }
  }
  return <div>{message}</div>;
}

GlobalMessage.propTypes = {
  text: PropTypes.string, // text to display on the global message
  visible: PropTypes.bool, // handles the visbility of the message
  messageType: PropTypes.string, //can be Bad or Good
  gotItButtonText: PropTypes.string, //if provided overrides the default button text
  gotItCallBack: PropTypes.func, //custom call back function when press got it button
  linkText: PropTypes.string, // text as a link on the global message
  linkCallBack: PropTypes.func, // custom call back func for the link
  enableHideAndBtn: PropTypes.bool, // This is to identify that we both enable autohide and button, so cb will not called when it's hidden
};
